<template>
  <div class="side-navigation-item">
    <div class="side-navigation-item__category-name-wrapper">
      <nuxt-link
        class="side-navigation-item__category-name"
        :active-class="'side-navigation-item__category-name--bold'"
        :class="{
          'side-navigation-item__category-name--level-one':
            category.depth === 1,
          'side-navigation-item__category-name--level-two':
            category.depth === 2,
          'side-navigation-item__category-name--level-other':
            category.depth > 2,
          'side-navigation-item__category-name--bold': pathArray.includes(
            category.slug,
          ),
        }"
        :to="linkCategoryTo(category)"
        :data-qa="category.parentId ? 'sub-category' : 'category'"
        :data-qa-category="category.parentId ? undefined : category.name"
        :data-qa-sub-category="category.parentId ? category.name : undefined"
        data-test-id="side-navigation-category-item-link"
        @click="trackNavigationClick"
      >
        <svg
          v-if="selectedCategory === category.slug"
          class="side-navigation-item__category-name-icon"
          width="7"
          height="10"
          viewBox="0 0 7 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.91629 5.86697L6 5M6 5L0.999999 1M6 5L1 9"
            stroke="black"
          />
        </svg>
        {{ category.name }}
      </nuxt-link>
    </div>
    <div
      v-if="
        pathArray &&
        pathArray.includes(category.slug) &&
        category.children &&
        category.children.length > 0
      "
      class="side-navigation-item__category-children"
    >
      <template v-for="(item, idx) in category.children" :key="item.id">
        <SideNavigationItem
          v-if="!isHiddenForPLPNavigation(item)"
          :category="item"
          :index="idx"
        />
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Category } from '@scayle/storefront-nuxt'

const props = defineProps({
  category: {
    type: Object as PropType<Category>,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
})

const route = useRoute()
const { trackNavigationSide } = useTrackingEvents()

const pathArray = computed((): string[] => {
  return route.path.split('/')
})

const selectedCategory = computed((): string | undefined => {
  return pathArray.value?.[pathArray.value?.length - 1]
})

const trackNavigationClick = () => {
  trackNavigationSide(props.category.name, props.category.depth)
}
</script>

<style lang="postcss" scoped>
.side-navigation-item__category-name-wrapper {
  @apply relative
  flex;
}
.side-navigation-item__category-name-icon {
  @apply absolute
  top-1
  -left-[15px];
}
.side-navigation-item__category-name {
  @apply relative
  text-base
  font-normal
  leading-[19px];
}
.side-navigation-item__category-name--bold {
  @apply !font-[800];
}
.side-navigation-item__category-name--level-one {
  @apply mb-[5px];
}
.side-navigation-item__category-name--level-two {
  @apply ml-[15px]
    mb-[5px];
}
.side-navigation-item__category-name--level-other {
  @apply font-light
    ml-[38px]
    mb-[4px];
}
.side-navigation-item__category-children {
  @apply my-[5px];
}
</style>
